import { useWorkspace } from '@/layouts/workspaceContext';
import { useTranslation } from 'react-i18next';
import { useMarket } from '@/app/market';
import { useMarketCatalog } from '@/lib/markets';
import { Combobox } from '@/ui';

const HEADER_MARKET_ID = 'header-market';

/** Opens the header's market picker: screens that need one market point here, not to a picker of their own. */
export function openHeaderMarket() {
  const trigger = document.getElementById(HEADER_MARKET_ID);
  trigger?.scrollIntoView?.({ block: 'nearest' });
  trigger?.focus();
  trigger?.click();
}

/** Header picker for the working market; "All my markets" = every market the caller can see. */
export function MarketSelect({ className }: { className?: string }) {
  const { t } = useTranslation('shell');
  const workspace = useWorkspace();
  const { areaId, setAreaId } = useMarket();
  const { options, isLoading } = useMarketCatalog();
  return (
    <Combobox
      id={HEADER_MARKET_ID}
      aria-label={t('header.market')}
      clearLabel={t('header.allMyMarkets')}
      searchPlaceholder={t('header.searchMarkets')}
      loading={isLoading}
      options={options}
      value={areaId}
      onValueChange={async (id) => {
        if (id === areaId) return;
        if (!workspace || await workspace.confirmMarketChange()) setAreaId(id ?? undefined);
      }}
      className={className}
    />
  );
}
